// extracted by mini-css-extract-plugin
export var active = "_go-2";
export var recordingDot = "_go-1";
export var recordingIndicator = "_go-0";